import { Controller } from '@hotwired/stimulus'

// Portada de cuentas (ENH-RNK-7023): las fotos de fondo del hero y de los rankings se
// quedan atrás al hacer scroll. Solo en escritorio (1024 px o más) y sin «reducir
// movimiento». Se mueven con transform en un requestAnimationFrame, sin tocar el layout.
//
// - `data-velocidad` (hero): la foto baja esa fracción de lo que baja la página.
// - `data-recorrido` (rankings): la foto se desplaza un 15 % de lo que se aleja su sección
//   del centro de la pantalla, como mucho ese número de píxeles.
export default class extends Controller {
  static targets = ['foto']

  connect () {
    this.escritorio = window.matchMedia('(min-width: 1024px)')
    this.sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.alHacerScroll = this.alHacerScroll.bind(this)
    window.addEventListener('scroll', this.alHacerScroll, { passive: true })
    window.addEventListener('resize', this.alHacerScroll, { passive: true })
    this.alHacerScroll()
  }

  disconnect () {
    window.removeEventListener('scroll', this.alHacerScroll)
    window.removeEventListener('resize', this.alHacerScroll)
    if (this.pendiente) cancelAnimationFrame(this.pendiente)
  }

  alHacerScroll () {
    if (this.pendiente) return

    this.pendiente = requestAnimationFrame(() => {
      this.pendiente = 0
      const activo = this.escritorio.matches && !this.sinMovimiento.matches
      this.fotoTargets.forEach((foto) => {
        foto.style.transform = activo ? `translate3d(0, ${this.desplazamiento(foto).toFixed(1)}px, 0)` : ''
      })
    })
  }

  desplazamiento (foto) {
    if (foto.dataset.velocidad) return Math.min(window.scrollY, 1200) * parseFloat(foto.dataset.velocidad)

    const caja = this.element.getBoundingClientRect()
    if (caja.bottom <= 0 || caja.top >= window.innerHeight) return 0

    const maximo = parseFloat(foto.dataset.recorrido)
    const distancia = (window.innerHeight / 2 - (caja.top + caja.height / 2)) * 0.15
    return Math.max(-maximo, Math.min(maximo, distancia))
  }
}
